import { render } from "./ClaimView.vue?vue&type=template&id=6850949e&scoped=true"
import script from "./ClaimView.vue?vue&type=script&lang=js"
export * from "./ClaimView.vue?vue&type=script&lang=js"

import "./ClaimView.vue?vue&type=style&index=0&id=6850949e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6850949e"]])

export default __exports__